import axios from 'axios';

import { appLocalStorageClear } from '../CommonFuctions/appLocalStorageClear';
import { AUTH_URL, clientId, metadata, source } from '../config';

export const logout = () => {
  try {
    const currentUrl = new URL(window.location.href);
    currentUrl.hash = '';
    currentUrl.searchParams.delete('_ts');
    const returnUrl = encodeURIComponent(currentUrl.toString());

    appLocalStorageClear();

    const logoutPath = '/logout';
    window.location.href = `${AUTH_URL}${logoutPath}?return_url=${returnUrl}&source=${source}`;
  } catch (error) {
    window.location.href = AUTH_URL;
  }
};

export const handleAuthError = (error) => {
  appLocalStorageClear();
  if (window.location.pathname.includes('/login')) return;

  const errorUrl = new URL(`${AUTH_URL}/login`);
  errorUrl.searchParams.set('error', 'auth_failed');
  errorUrl.searchParams.set('error_description', error.message || 'Authentication failed');
  window.location.href = errorUrl.toString();
};

export const redirectToLogin = () => {
  try {
    const loginPath = '/login';
    if (window.location.pathname === '/login') {
      const cleanReturnUrl = encodeURIComponent(window.location.origin);
      window.location.href = `${AUTH_URL}${loginPath}?return_url=${cleanReturnUrl}&_ts=${Date.now()}&source=${source}`;
      return;
    }

    const currentUrl = new URL(window.location.href);
    currentUrl.hash = '';
    currentUrl.searchParams.delete('_ts');

    const returnUrl = currentUrl.toString();

    const loginUrl = new URL(`${AUTH_URL}${loginPath}`);
    loginUrl.searchParams.set('return_url', returnUrl);
    loginUrl.searchParams.set('_ts', Date.now().toString());
    loginUrl.searchParams.set('source', source);
    loginUrl.searchParams.set('action', 'login');
    appLocalStorageClear();
    window.location.href = loginUrl.toString();
  } catch (error) {
    handleAuthError(error);
  }
};

let refreshPromise = null; // module-level to share between calls

export const getValidAccessToken = async () => {
  const expiry = localStorage.getItem('token_expires_at');
  const refreshToken = localStorage.getItem('refresh_token');
  const expiryMs = parseInt(expiry || '0', 10);

  // If we have no expiry or token, just return null
  const token = localStorage.getItem('access_token');
  if (!token || !expiryMs) {
    redirectToLogin();
  }

  const bufferMs = 60 * 1000; // 1 minute buffer
  const isExpired = Date.now() > expiryMs - bufferMs;

  if (isExpired) {
    // If no refresh in progress, start one
    if (!refreshPromise) {
      if (!refreshToken) {
        redirectToLogin();
      }
      refreshPromise = refreshTokens(refreshToken)
        .catch((err) => {
          console.error('Token refresh failed', err);
          return null; // Let caller handle null
        })
        .finally(() => {
          refreshPromise = null;
        });
    }

    await refreshPromise; // Wait for refresh (whether successful or failed)
    return localStorage.getItem('access_token'); // Return new token (or null)
  }

  // Token still valid
  return token;
};

async function refreshTokens(refreshToken) {
  try {
    const tokenResponse = await axios.post(
      metadata.token_endpoint,
      new URLSearchParams({
        client_id: clientId,
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
      }).toString(),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }
    );

    const newTokens = tokenResponse.data;

    if (newTokens?.access_token) {
      saveTokens(newTokens);
      return newTokens.access_token;
    }

    console.info('Refresh failed — user must log in again.');
    return null;
  } catch (error) {
    redirectToLogin();
    return null;
  }
}

export function saveTokens(tokenData) {
  if (tokenData?.access_token) {
    localStorage.setItem('access_token', tokenData.access_token);
  }
  if (tokenData?.refresh_token) {
    localStorage.setItem('refresh_token', tokenData.refresh_token);
  }
  // if (tokenData?.id_token) {
  //   localStorage.setItem('id_token', tokenData.id_token);
  // }
  if (tokenData?.expires_in) {
    localStorage.setItem('token_expires_at', String(Date.now() + tokenData.expires_in * 1000));
  }
}
